import React, {useContext, useState} from 'react';
import {formatDate, formatFileSize, getFullNameById, getInitials, getUserPermisson} from '../functions/utils';
import getFileIcon from '../functions/getFileIcon';
import {FilterContext} from '../context/filterContext';
import {fileHeaders} from '../../../constants/headers';
import FileUploadIcon from '../../../assests/img/file-upload.svg?react';
import SortIcon from '../../../assests/img/sort.svg?react';
import ViewIcon from '../../../assests/img/view.svg?react';
import EditIcon from '../../../assests/img/edit.svg?react';
import DownloadIcon from '../../../assests/img/file-download.svg?react';
import DeleteIcon from '../../../assests/img/delete.svg?react';
import {addFile} from '../api/postApi';
import {UserContext} from '../context/userContext';
import {toast} from 'react-toastify';
import Popup from './Popup';
import {deleteDataApi} from '../api/deleteApi';
import {updateDataApi} from '../api/updateApi';
import Edit from './Edit';
import TextInput from './TextInput';
import Loader from './Loader';
import {deleteFile, uploadFile} from '../functions/handleFiles';
import {AuthContext} from '../context/authContext';
import '../../../assests/css/files.scss';

export interface fileType {
    id: number,
    name: string,
    size: string,
    uploadedBy: number,
    uploadDate: string,
    url: string,
    blobName: string,
}

export interface fileProps {
    data: fileType[],
    groupId: number,
    getFiles: ()=> Promise<void>,
}

export default function Files(props: fileProps) {

    const [hoverId, setHoverId] = useState(-1);
    const [filesUploaded, setFilesUploaded] = useState<File[]>([]);
    const [file, setFile] = useState<fileType>();
    const [fileToUpdate, setFileToUpdate] = useState<fileType>();
    const [loading, setLoading] = useState(false);
    const {filterData: {users}} = useContext(FilterContext);
    const {data: {permissions}} = useContext(UserContext);
    const fileIconSize = {width: 16,  height: 16};
    const {data, groupId} = props;

    const {data: {userId}} = useContext(UserContext);
    const {accounts} = useContext(AuthContext);

    const handleView = (url: string) => window.open(url, "_blank");

    const handleUploadFile = async (files: FileList) => {
        setLoading(true);
        Array.from(files).forEach(async (eachFile)=> {
            const {fileUrl, blobName, res, error} =
                await toast.promise(uploadFile(eachFile, 'files'),
                {pending: `Uploading file - ${eachFile.name}`});
            if (!error && res?._response.status === 201) {
                const reqBody = {
                    name: eachFile.name,
                    uploadedBy: userId,
                    uploadedDate: new Date().toISOString(),
                    size: eachFile.size,
                    url: fileUrl,
                    CompanyGroupId: groupId,
                    blobName: blobName,
                }
                const uploadRes = await addFile(reqBody, accounts);
                if (uploadRes.status === 201) {
                    toast.success("File uploaded succesfully");
                    await props.getFiles();
                } else {
                    toast.error("File upload error");
                }
            } else if (error) {
                toast.error(error);
            }
        })
        setLoading(false);
    }

    const handleUploadFiles = (event: React.ChangeEvent<HTMLInputElement>) => {
        const tempFiles = event.target.files;
        if (tempFiles) {
            const temp = [];
            for (let i=0; i < tempFiles.length; i++) {
                temp.push(tempFiles[i]);
            }
            setFilesUploaded(temp);
        }
        if (tempFiles) {
            handleUploadFile(tempFiles);
        }
    }

    const handleDeleteFile = async (file: fileType | undefined) => {
        setLoading(true);
        if (file && file.blobName) {
            setFile(undefined);
            const {res, error} = await toast.promise(deleteFile(file, 'files'),
            {pending: `Deleteing file - ${file.name}`});
            if (!error && res?._response.status === 202) {
                const res = await deleteDataApi(`Files/id/${file.id}`,
                    accounts);
                if (res === 204) {
                    toast.success("File deleted succesfully");
                    setFile(undefined);
                    await props.getFiles();
                } else {
                    toast.error("Error deleting file");
                }
            } else if (error) {
                toast.error(error);
            }
        }
        setLoading(false);
    }

    const handleRenameFile = async () => {
        setLoading(true);
        if (fileToUpdate) {
            const reqBody = {
                name: fileToUpdate.name,
                UpdatedBy: userId,
                UpdatedDate: new Date().toISOString()
            }
            const res = await toast.promise(updateDataApi(
                `Files/id/${fileToUpdate.id}`, reqBody, accounts),
            {pending: 'Updating file name'});
            if (res === 200) {
                setFileToUpdate(undefined);
                toast.success("File name updated successfully");
                await props.getFiles();
            } else {
                toast.error("Faild to update file name");
            }
        }
        setLoading(false);
    }

    const setDeleteFile = (file: fileType) => {
        setFile(file);
    }

    return (
            <div className="states-container">
            <Popup title='Delete file'
                onClose={()=> setFile(undefined)}
                size='lg'
                show={file !== undefined? true: false}
                primaryCtaText='Delete'
                primaryCtaOnClick={()=> handleDeleteFile(file)}
                secondaryCtaOnClick={()=> setFile(undefined)}
                secondaryCtaText='Cancel'
                customClassName='file-delete-popup'>
                    Are you sure you want to delete file - ${file?.name}.
                    This action cannot be undone?
                </Popup>
            <div className="state-names file-upload-container">
            {getUserPermisson(permissions, 'C')?
            <>
            <input type="file" multiple={true} onChange={handleUploadFiles}/>
                <span> <FileUploadIcon width={32} height={32}/> </span>
                <span className="file-upload-text"> Drag & drop your file here </span>
                <span className="file-upload-text"> or
                    <span className="file-upload-text file-upload-link">
                        <span className="file-upload-text file-upload-link"> click here </span> 
                    </span> to upload </span></>: null}
                {filesUploaded.length?
                <div className="files-selected">
                    <span className="file-upload-text">Added {filesUploaded.length} file(s)</span>
                </div>: null}
            </div>
            {data.length?
            <div className="files-content-container">
                <table>
                    <thead>
                        <tr className="files-header">
                            {fileHeaders.map((header, index)=> {
                                return (
                                <th key={`file-${index}`}>
                                    <div className="files-header-content">
                                        <SortIcon width={18} height={18}/>
                                        <span className="files-header-text">{header}</span>
                                    </div>
                                </th>
                                );
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {!loading? data.map((file, index)=> {
                            return (
                            <tr key={`file-content-${index}`} className="files-header"  onMouseEnter={() => setHoverId(file.id)}
                                onMouseLeave={() => setHoverId(-1)}>
                                <td>
                                    <div className="file-name-container">
                                        <div>
                                            <img src={getFileIcon(file.name)}
                                                width={24} height={30}
                                                alt="format-icon" />
                                        </div>
                                        <div className="file-details">
                                            <span className="file-name">
                                                {fileToUpdate !== undefined &&
                                                    fileToUpdate.id === file.id?
                                                    <span className="edit-file-name">
                                                    <TextInput text={fileToUpdate.name} placeholder='File Name'
                                                    onChange={(text)=>
                                                        setFileToUpdate({...fileToUpdate, name: text})} type='text'
                                                    className='tiv-cms-tex-edit'/>
                                                <Edit onUpdate=
                                                    {handleRenameFile}
                                                    onClose={()=>
                                                    setFileToUpdate(undefined)}
                                                    />
                                                    </span>: file.name}
                                            </span>
                                            <span className="file-size">
                                                {formatFileSize(
                                                    parseInt(file.size))}
                                            </span>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="file-name-container">
                                        <span className="topbar-profile file-profile">
                                            {getInitials(getFullNameById(
                                                file.uploadedBy, users))}
                                        </span>
                                        <span className="file-uploaded-name">{getFullNameById(file.uploadedBy, users)}</span>
                                    </div>
                                </td>
                                <td>
                                    {hoverId === file.id?
                                    <div className="file-actions-content">
                                        <span className="files-seperator"></span>
                                        <span onClick={()=>
                                            handleView(file.url)}>
                                            <ViewIcon width={16} height={16}/>
                                        </span>
                                        {getUserPermisson(permissions, 'U')?
                                        <span>
                                            <EditIcon
                                                {...fileIconSize}
                                                onClick={()=>
                                                    setFileToUpdate(file)}/> 
                                        </span>: null}
                                        <span>
                                            <DownloadIcon onClick={() =>
                                                handleView(file.url)}
                                            {...fileIconSize}/>
                                        </span>
                                        {getUserPermisson(permissions, 'D')?
                                        <span>
                                            <DeleteIcon
                                                onClick={()=>
                                                    setDeleteFile(file)}
                                                {...fileIconSize}/>
                                        </span>: null}
                                    </div>: <div className="file-actions-container">
                                        <span className="file-uploaded-name">{formatDate(file.uploadDate)}</span>
                                    </div>}
                                </td>
                            </tr>
                            );
                        }): <Loader customClass='file-list-loader'/>}
                    </tbody>
                </table>
            </div>: <div className="no-files-container">
                   <span>No files to show</span>     
            </div>}
        </div>
    );

}